import { Drawer as DrawerPrimitive } from 'vaul';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './drawer.module.scss';
import Button from '../Button';

const DrawerClass = cva(styles.drawer, {
  variants: {},
  defaultVariants: {}
});

export type DrawerProps = VariantProps<typeof DrawerClass> & {
  className?: string;
  children: React.ReactNode;
  triggerClass?: string;
  triggerContent?: React.ReactNode;
  renderTrigger?: () => React.ReactNode;
} & React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Root>;

export default function Drawer({
  className,
  children,
  triggerClass,
  renderTrigger = () => <Button>Open</Button>,
  ...rootProps
}: DrawerProps) {
  return (
    <DrawerPrimitive.Root {...rootProps}>
      <div className={triggerClass}>
        <DrawerPrimitive.Trigger asChild>
          {renderTrigger()}
        </DrawerPrimitive.Trigger>
      </div>
      <DrawerPrimitive.Portal>
        <DrawerPrimitive.Overlay className={styles.overlay} />
        <DrawerPrimitive.Content className={DrawerClass({ className })}>
          <div className={styles.handleContainer}>
            <DrawerPrimitive.Handle className={styles.handle} />
          </div>
          <div className={styles.contentScrollContainer}>{children}</div>
        </DrawerPrimitive.Content>
      </DrawerPrimitive.Portal>
    </DrawerPrimitive.Root>
  );
}
